<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M16 5.00098C22.0749 5.00098 26.9995 9.92563 26.9995 16.0005C26.9995 22.0754 22.0749 27 16 27C9.92514 27 5.00049 22.0754 5.00049 16.0005C5.00049 9.92563 9.92514 5.00098 16 5.00098ZM24.9995 16.0005C24.9995 11.0302 20.9703 7.00098 16 7.00098C11.0297 7.00098 7.00049 11.0302 7.00049 16.0005C7.00049 20.9708 11.0297 25 16 25C20.9703 25 24.9995 20.9708 24.9995 16.0005Z"
        />
        <path
            d="M17.0186 20.5137C17.0186 21.066 16.5708 21.5137 16.0186 21.5137C15.4663 21.5137 15.0186 21.066 15.0186 20.5137C15.0186 19.9614 15.4663 19.5137 16.0186 19.5137C16.5708 19.5137 17.0186 19.9614 17.0186 20.5137Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M13.8851 10.8037H16.6056C17.2377 10.8037 17.847 11.04 18.3138 11.4661C19.4932 12.5426 19.3947 14.4285 18.1097 15.3764L17.4249 15.8815C17.1694 16.07 17.0186 16.3687 17.0186 16.6862V18.3359H15.0186V16.6862C15.0186 15.7335 15.4711 14.8375 16.2377 14.272L16.9225 13.7669C17.1931 13.5672 17.2139 13.17 16.9654 12.9432C16.8671 12.8535 16.7388 12.8037 16.6056 12.8037H13.8851V10.8037Z"
        />
    </svg>
</template>
